// export function installRipple() {
//     document.addEventListener(
//         'pointerdown',
//         (e) => {
//             const btn = (e.target as Element).closest<HTMLElement>('.btn')
//             if (!btn) return
//             if ((btn as HTMLButtonElement).disabled || btn.getAttribute('aria-disabled') === 'true')
//                 return

//             const r = btn.getBoundingClientRect()
//             const x = e.clientX - r.left
//             const y = e.clientY - r.top
//             // diameter that reaches the farthest corner
//             const d = 2 * Math.hypot(Math.max(x, r.width - x), Math.max(y, r.height - y))

//             const span = document.createElement('span')
//             span.className = 'hh-ripple'
//             span.style.cssText = `width:${d}px;height:${d}px;left:${x - d / 2}px;top:${y - d / 2}px`
//             btn.appendChild(span)
//             span.addEventListener('animationend', () => span.remove(), { once: true })
//         },
//         { passive: true }
//     )
// }

export function installRipple() {
    document.addEventListener(
        'pointerdown',
        (e) => {
            // const host = (e.target as Element).closest<HTMLElement>('.btn, .icon-btn')
            const host = (e.target as Element).closest<HTMLElement>('.btn')
            if (!host) return
            if (
                (host as HTMLButtonElement).disabled ||
                host.getAttribute('aria-disabled') === 'true'
            )
                return

            const surface = host.querySelector<HTMLElement>('.ripple-surface') ?? host
            const r = surface.getBoundingClientRect()
            const x = e.clientX - r.left
            const y = e.clientY - r.top
            const d = 2 * Math.hypot(Math.max(x, r.width - x), Math.max(y, r.height - y))

            const span = document.createElement('span')
            span.className = 'hh-ripple'
            span.style.cssText = `width:${d}px;height:${d}px;left:${x - d / 2}px;top:${y - d / 2}px`
            surface.appendChild(span)
            span.addEventListener('animationend', () => span.remove(), { once: true })
        },
        { passive: true }
    )
}
